import React from 'react';
import { connect } from 'react-redux';
import Step2 from 'registration/common/components/step2'

const mapStateToProps = ({user}) => ({user})

export default connect(mapStateToProps)(Step2);



// WEBPACK FOOTER //
// ./registration/common/containers/step2.jsx